module.exports = __webpack_public_path__ + "img/logo3.03854f8d.png";